import React from "react";

export const MdFastforward = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M480 256L262.4 110v292L480 256zM32 110v292l217.6-146L32 110z"/></svg>) as JSX.Element;
